import React from 'react'
import { Link } from 'gatsby'

import {
  Wrapper,
  Left,
  Right,
  Col,
  Icons,
  Logo,
  Insta,
  EHO,
  CookFox,
  MAG,
  DE,
} from './index.styled'

const Footer = ({ className }) => {
  return (
    <Wrapper className={className}>
      <Left>
        <Logo to="/" />
        {/* <Insta href={'http://google.com'} target={'_blank'} /> */}
      </Left>
      <Right>
        <Col className={'first'}>
          <div>
            335 8th Avenue
            <br />
            New York, NY 10001
          </div>
          <Link to="/legal/" className={'web-only'}>
            Legal
          </Link>

          <div className={'mob-only'}>
            {/* <a href={'tel:2127561257'}>212 756 1257</a> */}
            <a href={'mailto:leasing@mabelchelsea.com'}>
              leasing@mabelchelsea.com
            </a>
            <br />
          </div>
        </Col>
        <Col className={'links'}>
          <div className={'web-only'}>
            {/*  <a href={'tel:2127561257'}>212 756 1257</a> */}
            <a href={'mailto:leasing@mabelchelsea.com'}>
              leasing@mabelchelsea.com
            </a>
          </div>

          <div>
            <a
              href={'/nys-housing-and-anti-discrimination-notice_06.2024.pdf'}
              target={'_blank'}
            >
              Fair Housing Notice
            </a>
            <a href={'/fair-housing-notice.pdf'} target={'_blank'}>
              Notice for Reasonable Accommodations
            </a>
          </div>
          <Link to="/legal/" className={'mob-only'}>
            Legal
          </Link>
        </Col>
        <Col className={'last'}>
          <Icons>
            <MAG />
            <DE />
            <CookFox />
          </Icons>
          <EHO />
        </Col>
      </Right>
    </Wrapper>
  )
}

export default Footer
